document.addEventListener('DOMContentLoaded', (event) => {
    let listElement = document.querySelector('.sideoffer_list');
    var tooltipSuccess = document.querySelector('.tooltip.hover');

    document.querySelectorAll('.copy').forEach(item => {
        item.addEventListener('click', function() {
            let dataCopy = this.getAttribute('data-copy');
            if (navigator.clipboard) {
                navigator.clipboard.writeText(dataCopy).then(function() {
                    tooltipSuccess.textContent = "¡Código copiado!"
                    setTimeout(function() {
                        tooltipSuccess.textContent = "Copiar código"
                    }, 2000);
                    console.log('Copied to clipboard successfully!');
                }).catch(function(error) {
                    console.error('Unable to write to clipboard.', error);
                });
            } else {
                let textArea = document.createElement('textarea');
                textArea.value = dataCopy;
                textArea.style.top = "0";
                textArea.style.left = "0";
                textArea.style.position = "fixed";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand('copy');
                     tooltipSuccess.textContent = "¡Código copiado!"
                    setTimeout(function() {
                        tooltipSuccess.textContent = "Copiar código"
                    }, 2000);
                    console.log('Fallback: Copied to clipboard successfully!');
                } catch (err) {
                    console.error('Fallback: Unable to copy to clipboard', err);
                }
                document.body.removeChild(textArea);
            }
        });
    });
});